module.exports = __webpack_public_path__ + "img/interstitial_7.17065dfb.jpg";